import { DETERMINAR_PAGINA_ATUAL_CENTRO_CUSTO} from '../types'

export default function determinarPaginaAtualCentroCusto (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_CENTRO_CUSTO,
    payload: paginaAtual
  }
}
